import styled from 'styled-components';
import { COLORS, FONTS, breakPoint } from '@ertelecom/ui-react/assets/js/constants';
import Input from '@ertelecom/ui-react/components/input';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';

export const Container = styled.div`
  min-height: 136px;
  background: ${COLORS.white};
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);
  margin-top: 50px;
  margin-bottom: -50px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`;

export const MainText = styled.div`
  text-align: right;
  font-family: ${FONTS.light};
  font-size: 24px;
  line-height: 32px;
  margin: 20px 10px 0;
  @media (${breakPoint(768)}) {
    text-align: center;
  }
`;

export const EmailInput = styled(Input)`
  max-width: 454px;
  margin: 30px 10px 0;
`;

export const ButtonBlock = styled.div`
  flex-direction: column;
  width: 250px;
  margin: 30px 10px 0;
`;

export const Button = styled(StyledButton)`
    flex: 0 0 auto;
    height: 48px;
    padding: 9px 24px;
`;

export const Policy = styled.div`
    text-align: left;
    font-family: ${FONTS.light};
    font-size: 12px;
    line-height: 18px;
    color: ${COLORS.middleGray};
    display: inline;
    @media(${breakPoint(768)}) {
        text-align: center;
    }
`;

export const PolicyLink = styled.a`
    color: ${COLORS.middleGray};
    text-decoration: underline;
`;
